import { apiCall } from './gqlClient';

const GETPROVIDERADDRESSES_QUERY = `
  query getProviderAddresses {
    getProviderAddresses
    {
      id
			ownerType
			ownerId
			type
			label
			recipientName
			line1
			line2
			city
			region
			postcode
			country
			latitude
			longitude
			isDefault
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const getProviderAddressesApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERADDRESSES_QUERY, variables: {}, fragments });

const GETUSERADDRESSES_QUERY = `
  query getUserAddresses {
    getUserAddresses
    {
      id
			ownerType
			ownerId
			type
			label
			recipientName
			line1
			line2
			city
			region
			postcode
			country
			latitude
			longitude
			isDefault
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const getUserAddressesApiCall = async (fragments = null) => apiCall({ query: GETUSERADDRESSES_QUERY, variables: {}, fragments });

const SAVEADDRESS_QUERY = `
  mutation saveAddress($input: AddressInput!) {
    saveAddress(input: $input)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const saveAddressApiCall = async ({input}, fragments = null) => apiCall({ query: SAVEADDRESS_QUERY, variables: {input}, fragments });

const UPDATEADDRESS_QUERY = `
  mutation updateAddress($input: AddressInput!) {
    updateAddress(input: $input)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateAddressApiCall = async ({input}, fragments = null) => apiCall({ query: UPDATEADDRESS_QUERY, variables: {input}, fragments });

const DELETEADDRESS_QUERY = `
  mutation deleteAddress($id: String!) {
    deleteAddress(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteAddressApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEADDRESS_QUERY, variables: {id}, fragments });

const SETDEFAULTADDRESS_QUERY = `
  mutation setDefaultAddress($id: String!, $ownerType: String!, $ownerId: Float!, $type: String!) {
    setDefaultAddress(id: $id, ownerType: $ownerType, ownerId: $ownerId, type: $type)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const setDefaultAddressApiCall = async ({id, ownerType, ownerId, type}, fragments = null) => apiCall({ query: SETDEFAULTADDRESS_QUERY, variables: {id, ownerType, ownerId, type}, fragments });
